import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { CrmStore } from './types';

export const initCrmStoreState: CrmStore = {
  storeId: '',
  storeName: '',
  isEnabled: false,
  isInfluencerMode: false,
  hasSlackNotifications: false,
  draftReplyEnabled: false,
  slackChannelId: null,
  chats: {},
  saleChannels: [],
};

export const useCrmStore = create<CrmStore>()(
  immer(
    devtools(() => initCrmStoreState, {
      name: 'CrmStore',
    })
  )
);
